import { ErrorAPI } from 'api/Associado/methods';
import { AxiosError } from 'axios';
import LoadingScreen from 'components/LoadingScreen/LoadingScreen';
import SeletorContasParaVotoModal, { ISeletorContasParaVotoGenericProps } from 'components/SeletorContasParaVotoModal/SeletorContasParaVotoModal';
import UnauthorizedScreen from 'components/UnauthorizedScreen/UnauthorizedScreen';
import { AssembleiaStatus } from 'enuns/AssembleiaStatus';
import { AssociadoRoutePath } from 'library/Routes';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { connect, useDispatch, useSelector, useStore } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { bindActionCreators, Dispatch } from 'redux';
import { assembleiaAssociadoActionsDownloadDocument, assembleiaAssociadoActionsLoadDuvidas, assembleiaAssociadoActionsLoadEvent, assembleiasAssociadoActionsDeleteCurrentEvent, assembleiasAssociadoActionsLoadContas, assembleiasAssociadoActionsLoadTotalConvocacoes } from 'store/modules/AssembleiasAssociadoActions';
import { IAssembleiaAssociadoEvento, IAssembleiaContasAssociado } from 'store/modules/AssembleiasAssociadoReducer';
import { IAuthUserReducer } from 'store/modules/AuthReducer';
import { modalsActionsOpen } from 'store/modules/ModalsActions';
import { ModalsActionTypes } from 'store/modules/ModalsActionTypes';
import { IModalProps } from 'store/modules/ModalsReducer';
import { wsAssembleiasActionsSendMessage } from 'store/modules/WSAssembleiasActions';
import { IReducer } from 'store/Reducer';
import { getTotalContasSelecionadasOuNaoPeloUsuario, getTotalContasSelecionadasPeloUsuario, wsStartStop } from 'utils/AssembleiaUtils';
import AxiosErrorHandler from 'utils/AxiosErrorHandler';
import { getUniqueKey } from 'utils/KeyUtils';
import AssembleiaAssociadoLive from './AssembleiaAssociadoLive';
import Context, { AssembleiaAssociadoActionsDownloadDocument, AssembleiaAssociadoActionsLoadDuvidas } from './Context';
import PreAssembleia from './PreAssembleia';

interface RouteParams {
  id: string;
}

const mapStateToProps = (state: IReducer) => {
  return {
    usuario: state.auth.usuario,
    currentEvent: state.assembleias.currentEvent,
    loadingEvent: state.assembleias.loadingEvent,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      assembleiaAssociadoActionsLoadEvent,
      assembleiaAssociadoActionsDownloadDocument,
      assembleiasAssociadoActionsLoadContas,
      assembleiasAssociadoActionsDeleteCurrentEvent,
      assembleiaAssociadoActionsLoadDuvidas,
      modalsActionsOpen,
    },
    dispatch
  );

interface Props {
  usuario: IAuthUserReducer | undefined;
  loadingEvent: boolean;
  currentEvent: IAssembleiaAssociadoEvento | null;
  assembleiaAssociadoActionsLoadEvent: Function;
  assembleiaAssociadoActionsDownloadDocument: AssembleiaAssociadoActionsDownloadDocument;
  assembleiasAssociadoActionsLoadContas: (
    assembleiaId: number,
    cpfCnpj: string,
    callbackSuccess?: (contas: IAssembleiaContasAssociado) => void,
    callbackError?: (error: AxiosError<ErrorAPI>) => void
  ) => void;
  assembleiasAssociadoActionsDeleteCurrentEvent: Function;
  modalsActionsOpen: (
    component: React.ElementType,
    componentProps: IModalProps,
    key?: string
  ) => ModalsActionTypes;
  assembleiaAssociadoActionsLoadDuvidas: AssembleiaAssociadoActionsLoadDuvidas;
}

function AssembleiaAssociado({
  usuario,
  loadingEvent,
  currentEvent,
  assembleiaAssociadoActionsLoadEvent,
  assembleiaAssociadoActionsDownloadDocument,
  assembleiasAssociadoActionsLoadContas,
  assembleiasAssociadoActionsDeleteCurrentEvent,
  modalsActionsOpen,
  assembleiaAssociadoActionsLoadDuvidas,
}: Props) {
  const [sentWS, setSentWS] = useState(true);
  const { id } = useParams<RouteParams>();
  const modalContasUniqueKey = getUniqueKey();
  const [startOpenedSelecaoContas, setStartOpenedSelecaoContas] = useState(
    false
  );
  const reducerState: IReducer = useStore().getState();
  const dispatchAction = useDispatch();
  const wsAssembleias = useSelector((state: IReducer) => {
    return state.wsAssembleias;
  });
  const location = useLocation();
  const history = useHistory();

  const wsOpened = useMemo<boolean>(() => {
    return wsAssembleias.opened;
  }, [wsAssembleias])

  const abrirModalContas = useCallback(() => {
    modalsActionsOpen(
      SeletorContasParaVotoModal,
      {
        genericProps: {
          cpfCnpj: usuario?.cpfCnpj,
          assembleia: currentEvent,
          key: modalContasUniqueKey,
        } as ISeletorContasParaVotoGenericProps,
      },
      modalContasUniqueKey
    );
    setStartOpenedSelecaoContas(true);
  }, [
    modalsActionsOpen,
    usuario,
    currentEvent,
    modalContasUniqueKey,
    setStartOpenedSelecaoContas,
  ]);

  useEffect(() => {
    if (!startOpenedSelecaoContas && currentEvent && currentEvent.contasDisponiveis && usuario!.cpfCnpj) {
      const selecionadas = getTotalContasSelecionadasPeloUsuario(
        currentEvent?.contasDisponiveis,
        usuario!.cpfCnpj
      );
      const total = getTotalContasSelecionadasOuNaoPeloUsuario(
        currentEvent.contasDisponiveis,
        usuario!.cpfCnpj
      );
      if (selecionadas !== total && selecionadas === 0 && currentEvent.status === AssembleiaStatus.Live) {
        abrirModalContas();
      }
    }
  }, [startOpenedSelecaoContas, currentEvent, usuario, abrirModalContas]);

  const [initialized, setInitialized] = useState<boolean>(false);

  useEffect(() => {
    if (
      !loadingEvent &&
      currentEvent &&
      currentEvent.needLoadAssembleia &&
      !initialized) {
        assembleiaAssociadoActionsLoadEvent(
          parseInt(id),
          undefined,
          AxiosErrorHandler
        );
      }
  }, [initialized, currentEvent, loadingEvent, assembleiaAssociadoActionsLoadEvent, id])

  const sendWSMessage = useCallback(() => {
    const trySendMessage = () => {
      dispatchAction(
        wsAssembleiasActionsSendMessage(
          {
            "id": id,
            "status": null,
            "isChatAtivo": null,
            "presentes": null,
            "pautas": []
          },
          undefined,
          () => setTimeout(trySendMessage, 2000)
        )
      );
    }
    trySendMessage();
  }, [dispatchAction, id]);

  useEffect(() => {
    if (!sentWS && wsAssembleias.opened && currentEvent && currentEvent.idAssembleia === Number(id)) {
      setSentWS(true);
      sendWSMessage();
    }
  }, [setSentWS, sendWSMessage, sentWS, wsAssembleias, wsAssembleias.opened, currentEvent, id])

  useEffect(() => {
    if (initialized && currentEvent) {
      window.setTimeout(() => {
        if (initialized && currentEvent) {
          setInitialized(false);
        }
      }, 5000)
    }
  }, [currentEvent, initialized, setInitialized])

  useEffect(() => {
    if (
      reducerState.auth.usuario &&
      (reducerState.auth.usuario.perfil.associadoRoute.assembleias.pre.ver ||
        reducerState.auth.usuario.perfil.associadoRoute.assembleias.live.ver)
    ) {
      setInitialized(true);
      assembleiaAssociadoActionsLoadEvent(
        parseInt(id),
        undefined,
        (error: AxiosError<any>) => {
          AxiosErrorHandler(error);
          if (error.response?.status === 417) {
            history.push(AssociadoRoutePath)
          }
        }
      );
    }
    return () => {
      assembleiasAssociadoActionsDeleteCurrentEvent();
      setStartOpenedSelecaoContas(false);
      setInitialized(false);
    };
  }, [
    history,
    setInitialized,
    reducerState.auth.usuario,
    assembleiaAssociadoActionsLoadEvent,
    id,
    setStartOpenedSelecaoContas,
    assembleiasAssociadoActionsDeleteCurrentEvent,
  ]);

  useEffect(() => {
    if (
      currentEvent &&
      !loadingEvent &&
      currentEvent.idAssembleia === parseInt(id) &&
      (
        currentEvent.status === AssembleiaStatus.Pre ||
        currentEvent.status === AssembleiaStatus.Live ||
        currentEvent.status === AssembleiaStatus.Encerrado
      ) &&
      currentEvent.needLoadContas
    ) {
      assembleiasAssociadoActionsLoadContas(
        currentEvent.idAssembleia,
        usuario?.cpfCnpj || '',
      );
    }
  }, [
    usuario,
    loadingEvent,
    currentEvent,
    assembleiasAssociadoActionsLoadContas,
    id
  ]);

  useEffect(() => {
    if (!isNaN(Number(id))) {
      dispatchAction(
        assembleiasAssociadoActionsLoadTotalConvocacoes(Number(id))
      )
    }
  }, [id, dispatchAction])

  useEffect(() => {
    if (usuario) {
      wsStartStop(
        usuario,
        Number(id),
        dispatchAction,
        wsOpened
      )
    }
  }, [usuario, location, id, dispatchAction, wsOpened])

  if (reducerState.auth.usuario) {
    if (
      !reducerState.auth.usuario.perfil.associadoRoute.assembleias.pre.ver &&
      !reducerState.auth.usuario.perfil.associadoRoute.assembleias.live.ver
    ) {
      return <UnauthorizedScreen />;
    }
  }

  if (!currentEvent && loadingEvent) {
    return <LoadingScreen />;
  }

  if (
    currentEvent &&
    currentEvent.status === AssembleiaStatus.Pre
  ) {
    if (
      reducerState.auth.usuario &&
      reducerState.auth.usuario.perfil.associadoRoute.assembleias.pre.ver
    ) {
      return (
        <Context.Provider
          value={{
            cpf: usuario?.cpfCnpj,
            currentEvent,
            assembleiaAssociadoActionsDownloadDocument,
            assembleiaAssociadoActionsLoadDuvidas,
          }}
        >
          <PreAssembleia />
        </Context.Provider>
      );
    } else {
      return <UnauthorizedScreen />;
    }
  }

  if (
    currentEvent &&
    (
      currentEvent.status === AssembleiaStatus.Live ||
      currentEvent.status === AssembleiaStatus.Pos
    )
  ) {
    if (
      reducerState.auth.usuario &&
      reducerState.auth.usuario.perfil.associadoRoute.assembleias.live.ver
    ) {
      return (
        <Context.Provider
          value={{
            cpf: usuario?.cpfCnpj,
            currentEvent,
            assembleiaAssociadoActionsDownloadDocument,
            assembleiaAssociadoActionsLoadDuvidas,
          }}
        >
          <AssembleiaAssociadoLive />
        </Context.Provider>
      );
    } else {
      return <UnauthorizedScreen />;
    }
  }

  if (
    currentEvent &&
    currentEvent.status === AssembleiaStatus.Encerrado
  ) {
    return <AssembleiaAssociadoLive />;
  }

  return null;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AssembleiaAssociado);
